module.exports = __webpack_public_path__ + "img/card-banner-1.7c9ff003.png";